// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"AccessibilityModal_mainContent__liFMY"};